// extracted by mini-css-extract-plugin
export default {"container":"LoadingProvider_container__QTj+c"};